module.exports = __webpack_public_path__ + "videos/11.1fe6474.mp4";